/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Close_MenuInputs */

const en_nav_close_menu = /** @type {(inputs: Nav_Close_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close menu`)
};

const zh_hans1_nav_close_menu = /** @type {(inputs: Nav_Close_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭菜单`)
};

const pt_br2_nav_close_menu = /** @type {(inputs: Nav_Close_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar menu`)
};

const es_nav_close_menu = /** @type {(inputs: Nav_Close_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar menú`)
};

const fr_nav_close_menu = /** @type {(inputs: Nav_Close_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer le menu`)
};

const de_nav_close_menu = /** @type {(inputs: Nav_Close_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menü schließen`)
};

const ru_nav_close_menu = /** @type {(inputs: Nav_Close_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть меню`)
};

const it_nav_close_menu = /** @type {(inputs: Nav_Close_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi il menu`)
};

/**
* | output |
* | --- |
* | "Close menu" |
*
* @param {Nav_Close_MenuInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const nav_close_menu = /** @type {((inputs?: Nav_Close_MenuInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Close_MenuInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_nav_close_menu(inputs)
	if (locale === "pt-BR") return pt_br2_nav_close_menu(inputs)
	if (locale === "es") return es_nav_close_menu(inputs)
	if (locale === "fr") return fr_nav_close_menu(inputs)
	if (locale === "de") return de_nav_close_menu(inputs)
	if (locale === "ru") return ru_nav_close_menu(inputs)
	if (locale === "it") return it_nav_close_menu(inputs)
	return en_nav_close_menu(inputs)
});